import { render, staticRenderFns } from "./EhrPatientSearchDialog.vue?vue&type=template&id=8bce2736&scoped=true&lang=pug"
import script from "./EhrPatientSearchDialog.vue?vue&type=script&lang=js"
export * from "./EhrPatientSearchDialog.vue?vue&type=script&lang=js"
import style0 from "./EhrPatientSearchDialog.vue?vue&type=style&index=0&id=8bce2736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bce2736",
  null
  
)

export default component.exports